import React from 'react';
import { SliderForm } from './slider-form';

const MAX_LAST_FUNDING_YEAR = new Date().getFullYear();
const SINGLE_YEARS = 10;
const SINGLE_YEAR_ENDPOINTS = Array.from({ length: SINGLE_YEARS }, (_, i) => MAX_LAST_FUNDING_YEAR - SINGLE_YEARS + i);
// tslint:disable-next-line: no-magic-numbers
const ENDPOINTS = [0, 2000, 2010, ...SINGLE_YEAR_ENDPOINTS, MAX_LAST_FUNDING_YEAR];

export const LastFundingForm: React.FC<{
    readonly: boolean;
    filters: [number, number];
    onChange: (val: [number, number]) => void;
}> = ({ readonly, filters, onChange }) => {
    return (
        <SliderForm
            readonly={readonly}
            endpoints={ENDPOINTS}
            fieldName="Last Funding Round"
            value={filters}
            onChange={onChange}
        />
    );
};
